import difference from "lodash/difference";
import isEqual from "lodash/isEqual";
import { SearchDecorators } from "@graylog/server-api";
const DecoratorsUpdater = (newDecorators, oldDecorators) => {
  const newDecoratorIds = newDecorators.filter(({ id }) => id !== void 0).map(({ id }) => id).sort();
  const oldDecoratorIds = oldDecorators.map(({ id }) => id).sort();
  const oldDecoratorsById = oldDecorators.reduce((prev, cur) => cur.id ? { ...prev, [cur.id]: cur } : prev, {});
  const newDecoratorsById = newDecorators.reduce((prev, cur) => cur.id ? { ...prev, [cur.id]: cur } : prev, {});
  const createdDecorators = difference(newDecoratorIds, oldDecoratorIds).map(
    (newDecoratorId) => newDecoratorsById[newDecoratorId]
  );
  const updatedDecorators = newDecorators.filter(({ id }) => id).filter(
    (decorator) => decorator.id && oldDecoratorsById[decorator.id] && !isEqual(decorator, oldDecoratorsById[decorator.id])
  );
  const deletedDecoratorIds = difference(oldDecoratorIds, newDecoratorIds);
  return Promise.all([
    ...createdDecorators.map(({ id: _id, ...newDecorator }) => SearchDecorators.create(newDecorator)),
    ...updatedDecorators.map(
      (updatedDecorator) => SearchDecorators.update(updatedDecorator.id, updatedDecorator)
    ),
    ...deletedDecoratorIds.map((deletedID) => SearchDecorators.remove(deletedID))
  ]).then(() => {
  });
};
export default DecoratorsUpdater;
